export default "__VITE_ASSET__ByIymI7m__"